export const RECIPE_FILTERS = [
  { label: "All", match: null },
  { label: "Breakfast", match: ["Breakfast"] },
  { label: "High Protein", match: ["High Protein"] },
  { label: "Lunch", match: ["Lunch"] },
  { label: "Dinner", match: ["Dinner"] },
  { label: "Healthy Snacks", match: ["Healthy Snacks"] },
  { label: "Healthy Drinks", match: ["Healthy Drinks"] },
  { label: "Weight Management", match: ["Weight Management"] },
  { label: "Vegetarian", match: ["Vegetarian"] },
  { label: "Non-Vegetarian", match: ["Non-Vegetarian"] },
];

export const RECIPE_CATEGORIES = ["Breakfast", "High Protein", "Lunch", "Dinner", "Healthy Snacks", "Healthy Drinks"];

export const RECIPE_TAGS = ["Breakfast", "High Protein", "Lunch", "Dinner", "Healthy Snacks", "Healthy Drinks", "Weight Management", "Vegetarian", "Non-Vegetarian"];

export const NUTRITION_KEYS = ["Calories", "Protein", "Carbohydrate", "Fat", "Fiber"];

export const matchesRecipeFilter = (r, filter) => {
  if (!filter.match) return true;
  if (filter.match.includes(r.category)) return true;
  return (r.tags || []).some((t) => filter.match.includes(t));
};
